<template>
  <!-- 如果有内容则显示，没有内容不显示附加项 -->
  <div v-if="showAddition">
    <div class="title-and-inputarea">
      <!-- 标题 -->
      <span class="title">{{ title }}</span>
      <el-link class="change-button-style"
               v-if="editer_visable_prop"
               @click="editorAdditonClick"
               :underline="false"
               type="info"
               icon="el-icon-edit">{{ button_name }}</el-link>
      <el-link class="save-button-style"
               @click="addAdditionForSku()"
               v-if="show_save_cancle_button"
               :underline="false"
               style="float: right; padding-left: 10px"
               type="primary">添加附加项</el-link>
      <el-link class="save-button-style"
               v-if="show_save_cancle_button"
               @click="cancleButtonClick"
               :underline="false"
               style="float: right; padding-left: 10px"
               type="info">取消</el-link>
      <el-link class="save-button-style"
               v-if="show_save_cancle_button"
               @click="saveButtonClick"
               :underline="false"
               style="float: right"
               type="info"
               icon="el-icon-folder-checked">保存</el-link>
    </div>
    <!-- 内容展示: 如果有附加项显示附加项列表， 如果没有显示空 -->
    <div v-show="show_sku_addition_list">
      <!-- 套餐 有附加项时显示 -->
      <div class="addition-content-plan"
           v-if="show_content_visable_prop">
        <el-table :data="sku_addition_list"
                  style="width: 100%">
          <el-table-column prop="addition_name"
                           label="套餐附加项"
                           width="180"></el-table-column>
          <el-table-column prop="addition_info"
                           label="说明"></el-table-column>
          <el-table-column label="售价/元"
                           width="180">
            <template slot-scope="price">
              <div>{{(price.row.addition_price/100).toFixed(2)}}</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 套餐 没有选择附加项时显示 -->
      <div class="no-sku-additon-box"
           v-else>
        该套餐未添加附加项: 点击右侧浮动按钮选择附加项
      </div>
    </div>
    <!-- 套餐附加项 结束-->

    <!-- 选择/编辑 产品 附加项区域 -->
    <div class="select-editor-addition"
         v-show="show_select_editor_addition">
      <div>
        <addition-list-settiong ref="additionListSettiong"
                                @submitAddAddition="submitAddAddition"
                                :spuAdditionDataList="spu_addition_data_list"></addition-list-settiong>
      </div>
    </div>
    <!-- 产品附加项：结束 -->
  </div>
</template>

<script>
import AdditionListSetting from '../product/AdditionListSetting'
export default {
  name: 'congfi-and-select-Addition',
  components: {
    'addition-list-settiong': AdditionListSetting,
  },
  data() {
    return {
      showAddition: true, // 是否显示组件
      info: '',
      is_editor: '',
      editer_visable_prop: this.edit_visable,
      // 保存/取消 的 按钮 显示
      show_save_cancle_button: this.showSaveCancleButton,
      show_input_prop: this.show_editor,
      show_content_visable_prop: this.show_content_visable,
      show_select_additon_list: '',
      // 显示/隐藏 套餐附加项
      show_sku_addition_list: true,
      // 选择 或 编辑  产品附加项的区域
      show_select_editor_addition: false,
      // 输入组件
      input_textarea_width: '300px',
      // 套餐附加项
      sku_addition_list: this.skuAdditionList,
      spu_addition_data_list: [],
      active_value: false,
      no_active_value: true,
      editor_content: '', //编辑器内容
    }
  },
  created() {
    // if (this.show_content == "") {
    //   this.showAddition = false;
    // } else {
    //   this.showAddition = true;
    // }

    if (this.sku_addition_list == '') {
      this.show_content_visable_prop = false
    } else {
      this.show_content_visable_prop = true
    }
  },
  props: {
    title: String,
    button_name: String, // 编辑按钮的名字
    spu_id: Number,
    sku_id: Number,
    skuAdditionList: Array, // 获取的套餐 所含附加项
    attribuite: Number,
    // 样式
    // input_width: String,
    type: String,
    edit_visable: {
      type: Boolean,
      default: true,
    },
    showSaveCancleButton: {
      type: Boolean,
      default: false,
    },
    show_editor: {
      type: Boolean,
      default: false,
    },
    show_content_visable: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    // 监听添加附加项-成功
    submitAddAddition() {
      // 发送请求 获取当前套餐全部附加项
      this.$http
        .get(`/product/get_spu_addition?spu_id=${this.spu_id}`)
        .then((res) => {
          console.log(res)
          this.spu_addition_data_list = res.data.data
        })
    },
    // 复制文本信息pastContent
    pastContent(event) {
      // console.log(event.target.innerHTML);
      this.$copyText(event.target.innerHTML).then((res) => {
        this.$message({
          message: '信息已复制到剪贴板',
          type: 'success',
        })
      })
    },
    changeSellStatus() {},
    // 编辑时的 方法
    editorAdditonClick() {
      // 隐藏 我自己 按钮
      this.editer_visable_prop = false
      // 隐藏 该套餐 的附加项目
      this.show_sku_addition_list = false
      // 显示 选择/编辑 附加项的区域
      this.show_select_editor_addition = true
      // 显示 保存/取消编辑的 按钮
      this.show_save_cancle_button = true
      // 发送请求 获取当前套餐全部附加项
      this.$http
        .get(`/product/get_spu_addition?spu_id=${this.spu_id}`)
        .then((res) => {
          console.log(res)
          this.spu_addition_data_list = res.data.data
        })
    },
    // 取消编辑
    cancleButtonClick() {
      // 隐藏选择/编辑  附加项 区域
      this.show_select_editor_addition = false
      // 隐藏 自己
      this.show_save_cancle_button = false
      // 显示 该套餐 的附加项目
      this.show_sku_addition_list = true

      // 显示 编辑按钮
      this.editer_visable_prop = true
    },
    saveButtonClick() {
      // 从组件中获取 选择的 附加项id
      let renewItem = {
        addition_id_list: this.$refs.additionListSettiong.bandAdditionToSku,
        sku_id: this.sku_id,
      }
      // 执行绑定
      this.$http.post('/product/add_sku_addition', renewItem).then((res) => {
        if (res.data.errno == '0') {
          // 更新 数据 [更新 表格数据]
          this.sku_addition_list = res.data.data
          this.$notify({
            title: '成功',
            message: res.data.errmsg,
            type: 'success',
          })
          // 隐藏 选择/编辑  附加项 区域
          this.show_select_editor_addition = false
          // 隐藏 自己
          this.show_save_cancle_button = false
          // 显示 该套餐 的附加项目
          this.show_sku_addition_list = true
          // 显示 编辑按钮
          this.editer_visable_prop = true
        } else {
          this.$notify({
            title: '错误',
            message: res.data.errmsg,
            type: 'warning',
          })
        }
      })
      // this.show_save_cancle_button = false;
      // this.editer_visable_prop = true;
      // this.show_input_prop = false;
      // this.show_content_visable_prop = true;
      //
    },
    // 监听改变值
    content_change(content) {
      this.editor_content = content
    },
    // 打开添加附加项的对话框
    addAdditionForSku() {
      this.$refs.additionListSettiong.addAdditionDiolag(this.spu_id)
    },
  },
}
</script>

<style>
.title-and-inputarea {
  border-left: 5px solid #ff5420;
  padding: 0 5px;
}
.title-and-inputarea:hover .change-button-style {
  display: block;
}
.title {
  font-size: 15px;
  font-weight: bold;
  margin-bottom: 10px;
}
.edito_save_right {
  /* cursor: pointer; */
}

.addition-content {
  margin-top: 10px;
  padding: 20px;
  border: 1px solid coral;
  background-color: cornsilk;
}
.addition-content-plan {
  margin-top: 10px;
  border: 1px solid rgb(221, 221, 221);
}
.change-button-style {
  display: none;
  float: right;
  font-size: 10px;
}
.save-button-style {
  float: right;
  font-size: 10px;
}
/* v-bind 绑定两种class */
.class_name_one {
  width: 100px;
}
.class_name_two {
  width: 300px;
  margin-top: 10px;
  margin-bottom: 10px;
}
.no-sku-additon-box {
  border: 1px solid beige;
  color: rgb(143, 140, 140);
  padding: 10px;
  margin-top: 20px;
  text-align: center;
  width: auto;
}
</style>